import { equals } from 'ramda'
import { createSelectorCreator, defaultMemoize } from 'reselect'

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, equals)

export default createDeepEqualSelector
